import React, { useState } from "react";

const LayoutTab = ({ handleLayoutChange, selectedLayout,updateFacebookLikeButtonTabData,facebookLikeButtonTabData }) => {
    const [width, setWidth] = useState(facebookLikeButtonTabData.width);
    const [layoutType, setLayoutType] = useState(facebookLikeButtonTabData.layout_type);
    const [layoutTypeDropdownOpen, setLayoutTypeDropdownOpen] = useState(false);
    const [activeSizeType, setActiveSizeType] = useState(facebookLikeButtonTabData.size_type);
    const [showFriends, setShowFriends] = useState(Number(facebookLikeButtonTabData.is_show_friends));
    const [showShare, setShowShare] = useState(Number(facebookLikeButtonTabData.is_show_share));

    // Handlers Width Change
    const handleWidthChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 225;
        const MAX_SIZE = 1200;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setWidth(valueWithPx); 
        updateFacebookLikeButtonTabData("width", valueWithPx);
    };

    // Handlers Layout Type Change
    const handleLayoutTypeChange = (type) => {
        setLayoutType(type);
        updateFacebookLikeButtonTabData("layout_type", type);
        setLayoutTypeDropdownOpen(false);
    };

    // Handle Size Type change
    const handleActiveSizeTypeChange = (event) => {
        setActiveSizeType(event.target.value);
        updateFacebookLikeButtonTabData("size_type", event.target.value);
    };

     //Handlers Is Show Friends On Change
    const handleShowFriendsChange = (e) => {
        const checked = e.target.checked;
        setShowFriends(checked);
        updateFacebookLikeButtonTabData("is_show_friends", checked); 
    };

    //Handlers Is Show Share On Change
    const handleShowShareChange = (e) => {
        const checked = e.target.checked;
        setShowShare(checked);
        updateFacebookLikeButtonTabData("is_show_share", checked); 
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Layout</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Width (px)</span>
                    <em>{parseInt(width)}px</em>
                    <div className="slider-container">
                        <input
                            type="range"
                            min="225"
                            max="1200"
                            value={parseInt(width)}
                            onChange={handleWidthChange}
                        />
                    </div>
                </div>

                <div className="box-header-row">
                    <span>Layout</span>
                    <div className="color-pikr-box" onClick={() => setLayoutTypeDropdownOpen(!layoutTypeDropdownOpen)}>
                        <em>{layoutType}</em>
                        {layoutTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Standard","Box count","Button count","Button"].map((type) => (
                                    <li key={type} onClick={() => handleLayoutTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="box-header-row">
                    <p>Size</p>
                    <div className="left-cnater-right-button">
                        <label className="card-radio-btn">
                            <input type="radio" name="size_type" className="card-input-element d-none" value="small" onChange={handleActiveSizeTypeChange} checked={activeSizeType === "small"} />
                            <div className="card card-body">
                                <div className="content_sub">Small</div>
                            </div>
                        </label>
                        <label className="card-radio-btn">
                            <input type="radio" name="size_type" className="card-input-element d-none" value="large" onChange={handleActiveSizeTypeChange} checked={activeSizeType === "large"} />
                            <div className="card card-body">
                                <div className="content_sub">Large</div>
                            </div>
                        </label>
                    </div>
                </div>

                <div className="box-header-row">
                    <span>Show Friends</span>
                    <div className="form-group">
                        <input id="open_is_show_friends" className="chkbx-toggle" type="checkbox" checked={showFriends} onChange={handleShowFriendsChange} />
                        <label for="open_is_show_friends"></label> 
                    </div>
                </div>

                <div className="box-header-row">
                    <span>Show Share</span>
                    <div className="form-group">
                        <input id="open_is_show_share" className="chkbx-toggle" type="checkbox" checked={showShare} onChange={handleShowShareChange} />
                        <label for="open_is_show_share"></label> 
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LayoutTab;